import React, { useEffect, memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';

import { Label } from 'core';

import useStyles from './footer.styles';

function Footer({ onSubmit }) {
  const classes = useStyles();

  useEffect(() => {
    window.onbeforeunload = () => true;
  }, []);

  return (
    <div className={classNames(classes.container)}>
      <Grid container className={classNames(classes.footerInner)}>
        <div className={classNames(classes.footerItem)}>
          <Label className={classNames(classes.label)} type="subtitle1">
            Changes were requested
          </Label>
        </div>
        <div className={classNames(classes.footerItem)} />
        <Grid className={classNames(classes.footerItem, classes.last)}>
          <Button
            variant="contained"
            color="primary"
            data-cy="preview-policy-changes"
            onClick={onSubmit}
            className={classes.btn}
          >
            <Label className={classes.btnLabel}>Preview requested changes</Label>
          </Button>
        </Grid>
      </Grid>
    </div>
  );
}

Footer.propTypes = {
  onSubmit: PropTypes.func.isRequired
};

export default memo(Footer);
